import * as React from 'react';
import { useState } from 'react';
import { FormInput } from 'src/components/molecules';
import { FormInputVariant, FormState } from 'src/types';
import * as Validator from 'validator';
import LoginContainer from '../LoginContainer';

interface Props {
  email: string;
  onEmailChange: Function;
  handleOnClick: Function;
}

function LoginEmail(props: Props) {
  const [isEmailValid, setIsEmailValid] = useState(true);
  const getInputState = () => {
    if (!props.email || !props.email.length) {
      return FormState.DEFAULT;
    }
    return isEmailValid ? FormState.SUCCESS : FormState.DEFAULT;
  };

  const handleEmail = () => {
    if (isEmailValid) {
      props.handleOnClick();
    }
  };

  return (
    <div data-testid="code-input">
      <LoginContainer
        header="Log in"
        includeForm={true}
        buttonText="Continue"
        buttonOnClick={() => handleEmail()}
        data-testid="enter-email"
        buttonDisabled={!props.email || !props.email.length || !isEmailValid}
      >
        <FormInput
          label="Email"
          variant={FormInputVariant.INPUT}
          placeholder="Email"
          data-testid="code-input"
          state={getInputState()}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            props.onEmailChange(event.currentTarget.value);
            setIsEmailValid(Validator.isEmail(event.currentTarget.value));
          }}
          type="email"
          value={props.email}
          enterKeyAction={() => handleEmail()}
          $removeMarginBottom={true}
        />
      </LoginContainer>
    </div>
  );
}

export default LoginEmail;
